





































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";

import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { FILTRO_DEFAULT } from "@/models/administracao/usuario/FiltroCadastroUsuarioModel";
import {
  gruposList,
  GRUPO_DEFAULT,
} from "@/models/administracao/usuario/GrupoModel";
import { ValidationProvider } from "vee-validate";
import { PaginationModel } from "@/models/commons/PaginationModel";
import { cadastroUsuarioService } from "@/service/cadastro/administrativo/usuario/CadastroUsuarioService";
import {
  CadastroUsuarioModel,
  USUARIO_DEFAULT,
} from "@/models/administracao/usuario/CadastroUsuarioModel";
@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListagemUsuariosAdministrativos extends Vue {
  @Ref()
  nomeValidationObserver!: InstanceType<typeof ValidationProvider>;
  @Ref()
  nomeUsuarioValidationObserver!: InstanceType<typeof ValidationProvider>;
  @Ref()
  grupoValidationObserver!: InstanceType<typeof ValidationProvider>;

  efetuouPesquisa = false;
  filtroCadastroUsuarioModel = FILTRO_DEFAULT();
  resultado: CadastroUsuarioModel[] = [];
  loading = false;

  cabecalho = [
    { text: "Nome", value: "nome", sortable: false, width: "30%" },
    { text: "E-mail", value: "nomeUsuario", sortable: false },
    { text: "Grupo", value: "grupo", sortable: false, width: "20%" },
    { text: "Ações", value: "actions", sortable: false, width: "10%" },
  ];

  usuarioSelecionado: CadastroUsuarioModel = USUARIO_DEFAULT();

  exibeModalConfirmacao = false;
  loadingExcluir = false;

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  @Watch("filtroCadastroUsuarioModel.options.page")
  tratarPaginacao() {
    if (this.efetuouPesquisa) {
      this.obterDados();
    }
  }

  get grupos() {
    return gruposList;
  }

  get isNomePreenchido() {
    return (
      this.filtroCadastroUsuarioModel.nome &&
      this.filtroCadastroUsuarioModel.nome.length > 0
    );
  }

  get isNomeUsuarioPreenchido() {
    return (
      this.filtroCadastroUsuarioModel.email &&
      this.filtroCadastroUsuarioModel.email.length > 0
    );
  }

  get isGrupoPreenchido() {
    return (
      this.filtroCadastroUsuarioModel.grupo &&
      this.filtroCadastroUsuarioModel.grupo.nomeIntegracao &&
      this.filtroCadastroUsuarioModel.grupo.nomeIntegracao !=
        GRUPO_DEFAULT().nomeIntegracao
    );
  }

  @Watch("filtroCadastroUsuarioModel.nome")
  @Watch("filtroCadastroUsuarioModel.email")
  @Watch("filtroCadastroUsuarioModel.grupo")
  limparErros() {
    if (
      this.isNomePreenchido ||
      this.isNomeUsuarioPreenchido ||
      this.isGrupoPreenchido
    ) {
      this.nomeValidationObserver.reset();
      this.nomeUsuarioValidationObserver.reset();
      this.grupoValidationObserver.reset();
    }
  }

  obterDados() {
    if (
      this.isNomePreenchido ||
      this.isNomeUsuarioPreenchido ||
      this.isGrupoPreenchido
    ) {
      this.loading = true;
      cadastroUsuarioService
        .pesquisarUsuarios(this.filtroCadastroUsuarioModel)
        .then((pageModel) => {
          this.filtroCadastroUsuarioModel.options.itemsLength =
            pageModel.itemsLength || 0;
          this.resultado = pageModel.conteudo;
        })
        .finally(() => {
          this.loading = false;
          this.efetuouPesquisa = true;
        });
    } else {
      this.nomeValidationObserver.setErrors([
        "É necessário informar pelo menos um filtro",
      ]);
      this.nomeUsuarioValidationObserver.setErrors([" "]);
      this.grupoValidationObserver.setErrors([" "]);
    }
  }

  @Watch("filtroCadastroUsuarioModel.options.itemsPerPage")
  filtrar() {
    if (this.filtroCadastroUsuarioModel.options.page == 1) {
      this.obterDados();
    } else {
      this.filtroCadastroUsuarioModel.options.page = 1;
    }
  }

  solicitarExclusao(usuario: CadastroUsuarioModel) {
    this.usuarioSelecionado = usuario;
    this.exibeModalConfirmacao = true;
  }

  cancelarSolicitacaoExclusao() {
    this.usuarioSelecionado = USUARIO_DEFAULT();
    this.exibeModalConfirmacao = false;
  }

  excluir() {
    if (this.usuarioSelecionado.id) {
      this.loadingExcluir = true;
      cadastroUsuarioService
        .excluirUsuario(this.usuarioSelecionado.id)
        .then(() => {
          this.openDialog('success', 'Sucesso', `O usuário ${this.usuarioSelecionado.nome} foi excluído com sucesso`);
          this.exibeModalConfirmacao = false;
          this.usuarioSelecionado = USUARIO_DEFAULT();
        })
        .catch((err) => {
          this.openDialog('error', 'Erro', err.message);
          this.exibeModalConfirmacao = false;
        })
        .finally(() => {
          this.loadingExcluir = false;
        });
    }
  }

  abrirNovo() {
    this.$router.push({ name: "CadastroUsuarioAdministrativo" });
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    if (this.dialogType == 'success') {
      this.filtrar();
    }
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
